import { ShipmentModel } from "features/shared/shipmentCard.types";
import { usePanelViews } from "features/shared/usePanelViews.hook";
import { appStore } from "entities/App";
import { authStore } from "entities/Auth";
import { railCardDeleteModalStore } from "entities/RailCardDeleteModal";
import { isRailSearchShipmentModel, RailSearchCardModel, railSearchCardStore } from "entities/RailSearchCard";
import { voidFunc } from "shared/lib/common.lib";
import { useAppDispatch, useAppSelector } from "shared/lib/redux";
import { Nullable } from "shared/lib/typeCheck.lib";

type ShipmentCardModel = RailSearchCardModel;

// type FollowFunc = (card: RailSearchCardModel) => void;
type AskDeletingCardFunc = (card: ShipmentCardModel) => void;
type DeleteCardHandler = (card: ShipmentCardModel) => void;
type CancelDeletingSavedCardFunc = () => void;
type DeleteCardModalHandlerFunc = () => void;
type UseRailCardActionsReturnType = {
  deleteRailCardHandler: DeleteCardHandler;
  deleteRailCardModalHandler: DeleteCardModalHandlerFunc;
  cancelRailCardDeleting: CancelDeletingSavedCardFunc;
  //   railCardFollow: FollowFunc;
  //   isRailCardFollowLoading: boolean;
  //   isRailCardFollowButtonVisible: boolean;
  isRailCardDeleting: boolean;
};

type UseRailCardActionsParams = {
  cardToDelete?: Nullable<ShipmentModel>;
  setCardToDeleteAction?: (card: ShipmentModel) => {
    type: string;
    payload: ShipmentModel | null;
  };
  resetCardToDeleteAction?: () => {
    type: string;
  };
  //   removeFilteredCardAction: (
  //     cards: SeaSavedCardModel | AirSavedCardModel | RailSearchCardModel
  //   ) => PayloadAction<SeaSavedCardModel | AirSavedCardModel | RailSearchCardModel>;
  //   removeCardByTagAction: (
  //     cards: SeaSavedCardModel | AirSavedCardModel | RailSearchCardModel
  //   ) => PayloadAction<SeaSavedCardModel | AirSavedCardModel | RailSearchCardModel>;
  //   refreshTags: () => void;
};
export const useRailCardActions = ({
  cardToDelete,
  setCardToDeleteAction,
  resetCardToDeleteAction,
  //   removeFilteredCardAction,
  //   removeCardByTagAction,
  //   refreshTags,
}: UseRailCardActionsParams): UseRailCardActionsReturnType => {
  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector(authStore.selectors.isAuthenticated);
  const requestedFromUrl = useAppSelector(appStore.selectors.requestedFromUrl);
  //   const savedCards = useAppSelector(railSavedCardStore.selectors.savedCards);
  const searchCards = useAppSelector(railSearchCardStore.selectors.searchCards);
  const { showPreviousView, isCurrentViewOpenedCard } = usePanelViews();

  //   const removeSavedCardFromUI = (card: RailSearchCardModel) => {
  // dispatch(railSavedCardStore.actions.removeSavedCardAction(card));
  // dispatch(removeFilteredCardAction(card));
  // dispatch(removeCardByTagAction(card));
  //   };

  const resetDeleteModal = () => {
    dispatch(railCardDeleteModalStore.actions.closeDeleteModalAction());
    if (resetCardToDeleteAction) {
      dispatch(resetCardToDeleteAction());
    }
  };

  const handleModalDeleting = () => {
    resetDeleteModal();
    if (isAuthenticated) {
      //   refreshTags();
    }
    if (isCurrentViewOpenedCard) {
      showPreviousView();
    }
  };

  const askDeletingCard: AskDeletingCardFunc = (card) => {
    dispatch(railCardDeleteModalStore.actions.openDeleteCardModalAction());
    if (setCardToDeleteAction) {
      dispatch(setCardToDeleteAction(card));
    }
  };

  const createRailCardDeleteHandlers = (): {
    deleteRailCardHandler: DeleteCardHandler;
    deleteRailCardModalHandler: DeleteCardModalHandlerFunc;
  } => {
    // case 1: opened from url (and clicked delete button)
    if (isCurrentViewOpenedCard && requestedFromUrl) {
      return {
        deleteRailCardHandler: (card) => {
          askDeletingCard(card);
        },
        deleteRailCardModalHandler: () => {
          if (!cardToDelete) {
            handleModalDeleting();
            return;
          }

          if (!isAuthenticated && isRailSearchShipmentModel(cardToDelete)) {
            dispatch(railSearchCardStore.actions.removeSearchCardAction(cardToDelete));
            handleModalDeleting();
            return;
          }

          if (isAuthenticated && isRailSearchShipmentModel(cardToDelete) && cardToDelete.reference) {
            // const existingSavedCard = savedCards.find((c) => c.reference === cardToDelete.reference);

            // if (existingSavedCard) {
            //   deleteSavedCardRequest(existingSavedCard.id, {
            //     onSettled: () => {
            //       removeSavedCardFromUI(existingSavedCard);
            //       handleModalDeleting();
            //     },
            //   });
            //   return;
            // }

            const existingSearchCard = searchCards.find((c) => c.reference === cardToDelete.reference);

            if (existingSearchCard) {
              dispatch(railSearchCardStore.actions.removeSearchCardAction(cardToDelete));
              handleModalDeleting();
            }

            // getCards(
            //   { limit: 1, where: { reference: cardToDelete.reference } },
            //   {
            //     onSettled: (response) => {
            //       if (response?.length) {
            //         deleteSavedCardRequest(response[0].id, {
            //           onSettled: () => {
            //             removeCardsCache();
            //             handleModalDeleting();
            //           },
            //         });
            //       }
            //     },
            //   }
            // );
            return;
          }

          //   if (isRailSavedShipmentModel(cardToDelete)) {
          //     removeSavedCardFromUI(cardToDelete);
          //     deleteSavedCardRequest(cardToDelete.id, {
          //       onSettled: () => handleModalDeleting(),
          //     });
          //   }
        },
      };
    }

    // case 2: clicked delete button on openned card or closed card
    if (!requestedFromUrl) {
      return {
        deleteRailCardHandler: (card) => {
          askDeletingCard(card);
        },
        deleteRailCardModalHandler: () => {
          //   if (isRailSearchShipmentModel(cardToDelete)) {
          //     deleteSavedCardRequest(cardToDelete.id, {
          //       onSettled: () => {
          //         removeSavedCardFromUI(cardToDelete);
          //         handleModalDeleting();
          //       },
          //     });
          //     return;
          //   }
          if (isRailSearchShipmentModel(cardToDelete)) {
            dispatch(railSearchCardStore.actions.removeSearchCardAction(cardToDelete));
            handleModalDeleting();
            return;
          }
        },
      };
    }

    return {
      deleteRailCardHandler: voidFunc,
      deleteRailCardModalHandler: voidFunc,
    };
  };

  //   const follow: FollowFunc = (data) => {
  //     if (!data || !data?.reference) return;
  //     const { atd, etd, ata, eta, predictiveETA } = data;
  //     const { departureDate, arrivalDate } = resolveDateValues({ atd, etd, ata, eta, predictiveETA });
  //     const departureDateWithLocale = departureDate.value ? formatFollowCardDate(departureDate.value) : null;
  //     const arrivalDateWithLocale = arrivalDate.value ? formatFollowCardDate(arrivalDate.value) : null;

  //     followCard(
  //       {
  //         reference: data.reference,
  //         location: {
  //           pin: data.currentPin,
  //           from: data.fromDirection ?? null,
  //           to: data.toDirection ?? null,
  //           // TODO: replace with API data
  //           transport: SeaRouteTypesModel.SEA,
  //         },
  //         type: data.referenceType,
  //         equipments_count: data.containersAmount,
  //         carrier_scac: data.getCarrierScac(),
  //         carrier_name: data.carrierName ?? null,
  //         status: data.status ?? ShipmentStatusesModel.UNKNOWN,
  //         size_type: JSON.stringify(data.containersSizeTypes),
  //         date: {
  //           from_actual: departureDate.isActual,
  //           from: departureDateWithLocale,
  //           to_actual: arrivalDate.isActual,
  //           to: arrivalDate.isPredictive ? null : arrivalDateWithLocale,
  //           to_predictive: arrivalDate.isPredictive ? arrivalDate.value : null,
  //         },
  //         updated_at: formatApiDate(new Date()),
  //       },
  //       {
  //         onSuccess: (response) => {
  //           dispatch(seaSearchCardStore.actions.removeSearchCardAction(data));
  //           dispatch(seaSavedCardStore.actions.prependSavedCardAction({ data: response }));
  //         },
  //       }
  //     );
  //   };

  const cancelRailCardDeleting: CancelDeletingSavedCardFunc = () => {
    // if (isSavedCardDeleting) return;
    resetDeleteModal();
  };

  return {
    ...createRailCardDeleteHandlers(),
    cancelRailCardDeleting,
    // TODO: replace with real value
    isRailCardDeleting: false,
    // railCardFollow: follow,
    // isRailCardFollowLoading: isCardFollowLoading,
    // isRailCardFollowButtonVisible: typeof followedCard === "undefined" && isAuthenticated,
    // isRailCardDeleting: isSavedCardDeleting,
  };
};
